import React from 'react';
import BookingAgreementGenerator from '../components/BookingAgreementGenerator';  // Assuming this is the correct path to the component

function AgreementGeneratorPage() {
  return (
    <div className="AgreementGeneratorPage">
      <BookingAgreementGenerator />
    </div>
  );
}

export default AgreementGeneratorPage;
